import React, { useState } from "react";
import { createPortal } from "react-dom";
import "./ReportButton.css";
import api from "../services/api";

const reasons = [
  { value: "spam", label: "垃圾內容" },
  { value: "abuse", label: "仇恨/騷擾" },
  { value: "false_info", label: "虛假資訊" },
  { value: "inappropriate", label: "不當內容" },
  { value: "other", label: "其他" },
];

const ReportButton = ({ postId, reportedUserId, isInDropdown = false }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [step, setStep] = useState("select");
  const [reason, setReason] = useState("");
  const [description, setDescription] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const submitReport = async (payload) => {
    try {
      await api.post("/reports/", payload);
      alert("已收到您的檢舉，感謝您的協助！");
    } catch (err) {
      console.error("Report failed:", err);
      alert("提交失敗，請稍後再試");
    } finally {
      setIsOpen(false);
      setStep("select");
      setReason("");
      setDescription("");
      setIsSubmitting(false);
    }
  };

  const handleSelectReason = (val) => {
    setReason(val);
    if (val === "other") {
      setStep("detail");
    } else {
      setIsSubmitting(true);
      submitReport({
        reason: val,
        description: "",
        post: postId || null,
        reported_user: reportedUserId || null,
      });
    }
  };

  const handleDetailSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    submitReport({
      reason,
      description,
      post: postId || null,
      reported_user: reportedUserId || null,
    });
  };

  return (
    <div className="report-button-wrapper">
      <button 
        className={isInDropdown ? "dropdown-report-button" : "report-entry-button"} 
        onClick={() => setIsOpen(true)}
      >
        檢舉
      </button>

      {isOpen &&
        typeof document !== "undefined" &&
        createPortal(
          <div className="report-modal-backdrop" onClick={() => setIsOpen(false)}>
            <div className="report-modal-card" onClick={(e) => e.stopPropagation()}>
              <div className="report-card-content">
                {step === "select" && (
                  <>
                    <h3>檢舉原因</h3>
                    <ul className="reason-list">
                      {reasons.map((r) => (
                        <li key={r.value}>
                          <button
                            type="button"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleSelectReason(r.value);
                            }}
                            className="reason-button"
                            disabled={isSubmitting}
                          >
                            {r.label}
                          </button>
                        </li>
                      ))}
                    </ul>
                    <button
                      type="button"
                      onClick={(e) => {
                        e.stopPropagation();
                        setIsOpen(false);
                      }}
                      className="cancel-button"
                    >
                      取消
                    </button>
                  </>
                )}

                {step === "detail" && (
                  <form onSubmit={(e) => {
                    e.stopPropagation();
                    handleDetailSubmit(e);
                  }}>
                    <h3>請說明詳細內容（選填）</h3>
                    <textarea
                      value={description}
                      onChange={(e) => setDescription(e.target.value)}
                      onClick={(e) => e.stopPropagation()}
                      placeholder="請描述發生什麼事..."
                      rows="4"
                    />
                    <div className="form-actions">
                      <button type="submit" disabled={isSubmitting} onClick={(e) => e.stopPropagation()}>
                        {isSubmitting ? "提交中..." : "提交檢舉"}
                      </button>
                      <button
                        type="button"
                        onClick={(e) => {
                          e.stopPropagation();
                          setIsOpen(false);
                        }}
                        className="cancel-button"
                      >
                        取消
                      </button>
                    </div>
                  </form>
                )}
              </div>
            </div>
          </div>,
          document.body
        )}
    </div>
  );
};

export default ReportButton;
